import styled from "@emotion/styled";

import { HeaderSubKind } from "../../Layout/SimpleTable/HeaderSubKind";
import { HorizontalAlign } from "../../Layout/SimpleTable/HorizontalAlign";
import { VerticalAlign } from "../../Layout/SimpleTable/VerticalAlign";
import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    subKind?: HeaderSubKind;
    isGray?: boolean;
    indent?: number;
    horizontalAlign?: HorizontalAlign;
    verticalAlign?: VerticalAlign;
}

export const Root = styled.td<RootProps>(
    props => ({
        color: theme(props).tables.headers.smallFont.color,
    }),
    props =>
        props.subKind !== "numbers"
            ? {
                  ...theme(props).tables.headers.smallFont.css(),
                  padding: "10px 5px",
                  letterSpacing: "0.005em",
                  textAlign: props.horizontalAlign,
                  verticalAlign: "bottom",
              }
            : {
                  verticalAlign: props.verticalAlign,
              },
    props =>
        props.isGray && {
            textAlign: props.horizontalAlign ?? "center",
        },
    props => props.indent != undefined && isFinite(props.indent) && { paddingLeft: 12 + props.indent * 12 }
);

export const EmptyCell = styled.td<RootProps>();
